import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

@Component({
    selector: "ev-sidebar",
    imports: [],
    templateUrl: "./ev-sidebar.component.html",
    styleUrl: "./ev-sidebar.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvSidebarComponent {
    readonly visible = input<boolean>(false);
    readonly sidebarPosition = input<string>("right");
    readonly topPosition = input<number>(0);
    readonly styles = input<{}>({});
    readonly onClose = output<void>();

    readonly computedTop = computed(() => 
    `calc(var(--banner-height, 0px) + ${this.topPosition()}px)`
);

    close(): void {
        this.onClose.emit();
    }
}
